<template>
  <span :class="clazz">
    <button
      v-if="attributes.label"
      :class="button_clazz"
      v-on:click="doAction()"
    >
      {{ label }}
    </button>
    <span class="img">
      <imgWidget v-if="img" :img="img" v-on:click="doAction()"> </imgWidget>
      <md-tooltip md-direction="right">
        {{ help }}
      </md-tooltip>
    </span>
  </span>
</template>
<script>
import componentMixin from "ireal-vue/mixins/component-mixin.js";
import imgWidget from "ireal-vue/widgets/ImgWidget.vue";

export default {
  name: "button-component",
  mixins: [componentMixin],
  components: { imgWidget },
  computed: {
    img() {
      return this.attributes.img;
    },
    button_clazz() {
      return `btn btn-primary text-uppercase ${this.attributes.button_class}`;
    },
    label() {
      return this.tx(this.attributes.label) || "";
    },
    help() {
      var model_help = `${this.attributes.model}_help`;
      return this.attributes.model !== undefined ? this.tx(model_help) : "";
    }
  }
};
</script>
<style scoped>
span {
  white-space: normal;
}
button {
  display: inline-block;
  white-space: normal;
}
</style>
